module.exports = __webpack_public_path__ + "img/tab-icon6.2426ac93.png";